import React from 'react';
import { BellIcon, EnterIcon } from '@radix-ui/react-icons';
import { Badge, DropdownMenu, IconButton } from '@radix-ui/themes';
import { Capacitor } from '@capacitor/core';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import magazineLogo from 'assets/images/tt_magazine.png';
import { isLoggedIn } from 'helpers/authentication';
import { useWindowSize } from 'helpers/useWindowSize';
import { openMagazine } from 'helpers/utils';
import { useAppSelector } from 'store/store';
import DropDownMenu from './DropDownMenu';
import Logo from './Logo';
import NotificationHeader from './NotificationHeader';
import SearchBar from './SearchBar';

const Header: React.FC = () => {
  const { counter, message_counter } = useAppSelector((state) => state.notifications);
  const hasNotification = counter > 0;

  const size = useWindowSize();
  const isMobileOnly = size.width < 768;
  const headerClassName = classNames(
    'text-sm md:text-base',
    'flex justify-between items-center self-stretch',
    { 'pt-6': !Capacitor.isNativePlatform() },
    { 'pt-16': Capacitor.isNativePlatform() },
    'md:pt-3 px-4 md:px-2 py-3',
    'border border-b border-solid border-accent-accent-8',
    'bg-accent-accent-6',
    'rounded-t-none rounded-b-2xl md:rounded-b-none',
  );

  const iconClassName = classNames(
    'min-w-10',
    'border border-solid border-accent-accent-6',
    'hover:border-accent-accent-8 hover:bg-accent-accent-3 hover:rounded-xl',
    'cursor-pointer',
  );

  return (
    <header className={headerClassName} data-testid='header'>
      <div className='flex items-center gap-6'>
        <Link to='/' aria-label='HomePage di TennisTalker'>
          <Logo />
        </Link>
      </div>
      <div className='flex items-center gap-2'>
        {!isMobileOnly && (
          <div onClick={openMagazine}>
            <IconButton
              variant='ghost'
              className={`${iconClassName} mr-2 rounded-md bg-neutral-neutral-alpha-3 py-1`}
              aria-label='TennisTalker Magazine'
            >
              <img src={magazineLogo} alt='tennistalker magazine' height='18' />
            </IconButton>
          </div>
        )}

        <SearchBar />
        {isLoggedIn() ? (
          <DropdownMenu.Root>
            <DropdownMenu.Trigger>
              <IconButton variant='ghost' className={`${iconClassName} relative`} aria-label='Notifiche'>
                <BellIcon width='18' height='18' />
                {hasNotification && (
                  <Badge size={'1'} variant='solid' color='tomato' className='absolute right-0 top-[-8px]'>
                    {counter}
                  </Badge>
                )}
              </IconButton>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content className='flex w-96 flex-col items-start gap-2 self-stretch rounded-2xl border border-solid border-neutral-neutral-4 bg-neutral-neutral-1 p-2'>
              <NotificationHeader counter={counter} />
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        ) : (
          <Link to='/accedi'>
            <div className='flex cursor-pointer gap-2 rounded-md bg-neutral-neutral-alpha-3 px-3 py-2 hover:bg-neutral-neutral-alpha-8'>
              <EnterIcon width='18' height='18' />
              Accedi
            </div>
          </Link>
        )}
        <DropDownMenu iconClassName={iconClassName} message_counter={message_counter} isMobileOnly={isMobileOnly} />
      </div>
    </header>
  );
};

export default Header;
